/**
 * Extracts engine, provider, and extra from a selected payment method with fallback defaults.
 * @param {object} selectedPaymentMethod - The selected payment method object from purchase state.
 * @param {object} options - defaultEngine, defaultProvider.
 * @param {string} options.defaultEngine - Fallback engine when method has none.
 * @param {string} [options.defaultProvider] - Fallback provider when method has none.
 * @returns {{ engine: string, provider: string|undefined, extra: object }}
 */
export default function getPaymentEngineAndProvider(
  selectedPaymentMethod,
  { defaultEngine, defaultProvider } = {},
) {
  const engine = selectedPaymentMethod?.engine ?? defaultEngine;
  const provider = selectedPaymentMethod?.provider ?? defaultProvider;
  const extra = selectedPaymentMethod?.extra ?? {};
  return { engine, provider, extra };
}
